import React from 'react';
import Layout from '../components/Layout';

const SettingsPage = () => (
  <Layout>
    <h2>Settings Page</h2>
  </Layout>
);

export default SettingsPage; 